var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagAntiguaAndBarbuda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_14882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0001C0 17.096 0.1105 18.1662 0.320437 19.2001L16 20.174L31.6796 19.2001C31.8896 18.1662 32 17.096 32 16.0001C32 14.9042 31.8895 13.834 31.6796 12.8001L16 11.8262L0.320437 12.8001C0.1105 13.834 0 14.9042 0 16.0001H0Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6796 19.2H0.320435C1.80287 26.5031 8.25943 32 16 32C23.7406 32 30.1971 26.5031 31.6796 19.2Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.320435 12.8H31.6797C30.1971 5.49688 23.7407 0 16 0C8.25931 0 1.80287 5.49688 0.320435 12.8Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9569 12.8001H9.04395L11.8864 11.4629L10.3728 8.71012L13.4593 9.30044L13.8506 6.18237L16.0004 8.47575L18.1504 6.18237L18.5414 9.30044L21.6281 8.71012L20.1146 11.4631L22.9569 12.8001Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 24.8365 7.1635 32 16 32L3.19975 6.39941C1.19075 9.07373 0 12.3977 0 16Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8365 32 32 24.8365 32 16C32 12.3977 30.8092 9.07373 28.8002 6.39941L16 32Z",
    fill: "#A2001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_14882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagAntiguaAndBarbuda);
export default __webpack_public_path__ + "static/media/flag_antigua_and_barbuda.e29aa87a4b7643762f6fd78fd3975de0.svg";
export { ForwardRef as ReactComponent };